import React from 'react';
import { Card, Button, Badge, Form, InputGroup } from 'react-bootstrap';
import './TripBooking.css';
import { upcomingTrip, tripHistory } from '../data/tripData';
import MasterPage from '../Templates/MasterPage';
import Footer from '../Templates/Footer';
import { useEffect,useState } from 'react';
import { server } from "../server";
import { Company_Id, Corporate_Id, Vendor_Id,Corporate_Name,Vendor_Name } from "../Helper";
import { Navigate, useNavigate } from 'react-router';
import Swal from 'sweetalert2';

const TripBooking = () => {
    const navigate = useNavigate();
    let userId = localStorage.getItem("userid");
    let userMobNo = localStorage.getItem("contactNo");
    let userName = localStorage.getItem("userName");
    let userEmailId = localStorage.getItem("emailId");
    let JWTToken = localStorage.getItem("Token");
    const localstorage1=localStorage.getItem("userid");
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        if (localstorage1==null) {
          navigate('/');
        }
      }, [localstorage1]);
    
    const [UserTravelHistory, setUserTravelHistory] = React.useState([]);
    useEffect(() => {
        // This effect can be used to fetch data or perform any setup when the component mounts
        // For example, you can fetch trip data from an API or perform any necessary initialization
        fetchTripData();
    }
        , []);
          const [selectedStatus, setSelectedStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
 
// const filteredTrips = UserTravelHistory?.filter((trip) => {
//   const combinedText = `${trip.JobNo} ${trip.TypeOfTrip} ${trip.RequestedPickUpTime} ${trip.PickupAddress} ${trip.DropOffAddress} ${trip.BillingType} ${trip.VehicleModel} ${trip.VehicleNo} ${trip.DriverName} ${trip.DriverMobileNo}`.toLowerCase();
// //   console.log(combinedText.includes(searchTerm.toLowerCase()))
//   return combinedText.includes(searchTerm.toLowerCase());
// });

const filteredTrips = UserTravelHistory?.filter((trip) => {
  const matchesSearch = `${trip.JobNo} ${trip.TypeOfTrip} ${trip.PickupAddress} ${trip.DropOffAddress} ${trip.VehicleModel} ${trip.VehicleNo} ${trip.DriverName} ${trip.DriverMobileNo}`
    .toLowerCase()
    .includes(searchTerm.toLowerCase());

  const matchesStatus = selectedStatus === "" || trip.JobStatus === selectedStatus;

  return matchesSearch && matchesStatus;
});


    const currentTime = new Date();
    async function fetchTripData() {
        try {
            const response = await fetch(`${server}/api/Siemens/fetchTripData`, {
                method: "POST",
                headers: {
                    Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CompanyId: `${Company_Id()}`,
                    EmpId: `${userId}`,
                    CorporateId: `${Corporate_Id()}`,
                    VendorId: `${Vendor_Id()}`,
                    MobileNo: `${userMobNo}`
                }),
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const body = await response.json();
            if (response.status == 401) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Session Expired Please Login Again",
                });
                // navigate("/Login");
            }
            // console.log("setUserTravelHistory response:", body.data);
            setUserTravelHistory(body.data);


        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "SomeThing Went wrong Please Try Again",
            });
        }
    }
async function Canceltrip( JobNo,Id) {
        // e.preventDefault();
        try {

            const confirmResult = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you really want to cancel this trip?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, cancel it!',
    });

    if (!confirmResult.isConfirmed) {
        return; // User cancelled the action
    }
            const response = await fetch(`${server}/api/Siemens/CancelJob`, {
                method: "POST",
                headers: {
                    Authorisation: `${JWTToken}`, // Fix spelling: 'Authorization'
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CompanyId: `${Company_Id()}`,
                    EmpId: `${userId}`,
                    CorporateId: `${Corporate_Id()}`,
                    VendorId: `${Vendor_Id()}`,
                    JobNo: `${JobNo}`,
                    CancelReason: "User Cancelled",
                    Remarks: "",
                    CancellationFare: "0",
                    Id: `${Id}`,
                    MobileNo: `${userMobNo}`
                }),
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
           // console.log("response:", response);
            const body = await response.json();
             
            if (body.status == 401) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Session Expired Please Login Again",
                });
                // navigate("/Login");
            } 
            if (body.statusCode == 200) {
               
                Swal.fire(
                        'Success',
                        'Trip Cancelation Successful.',
                        'success'
                      )
                // navigate("/Login");
            }
             
            fetchTripData(); // Refresh the trip data after cancellation
            // console.log("setUserTravelHistory response:", body.data);
            // setUserTravelHistory(body.data);


        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "SomeThing Went wrong Please Try Again",
            });
        }
    }
    // const Canceltrip = (JobNo, Id) => async (e) => {
    //     e.preventDefault();
    //     console.log("Cancel trip called with JobNo:", JobNo, "and Id:", Id);
    // }
    var upcomingTrips = UserTravelHistory.filter(trip =>

        new Date(trip.RequestedPickUpTime) > currentTime // Compare times
    );
    return (
        <>
            <MasterPage heading="Trip History" />
            <div className="content-wrapper" style={{ minHeight: '905px' }}>
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                {/* <h1>Trip Booking</h1> */}
                            </div>
                            {/* <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="#">Home</a></li>
                                    <li className="breadcrumb-item active">Trip Booking</li>
                                </ol>
                            </div> */}
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="trip-booking-container">

                            <div className="booking-section mb-4">
                                {upcomingTrips.length > 0 && (
                                    <h4 className="section-title">Upcoming Trip</h4>
                                )}

                                {/* <Card className="trip-card p-3">
                                    <div className="d-flex flex-wrap align-items-center">
                                        <div className="col-2">
                                            <div><strong>Booking ID:</strong> {upcomingTrip.bookingId}</div>
                                            <div>{upcomingTrip.tripType}</div>
                                            <div>{upcomingTrip.dateTime}</div>
                                        </div>

                                        <div className="col-6">
                                            <div className="d-flex align-items-start mb-2">
                                                <img
                                                    src="dist/img/location-green.png"
                                                    alt="Pickup"
                                                    style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
                                                />
                                                <div>{upcomingTrip.pickup}</div>
                                            </div>
                                            <div className="d-flex align-items-start">
                                                <img
                                                    src="dist/img/location-blue.png"
                                                    alt="Drop"
                                                    style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
                                                />
                                                <div>{upcomingTrip.drop}</div>
                                            </div>
                                        </div>

                                        <div className="col-1">
                                            <div><strong>Fare</strong></div>
                                            <div>₹ {upcomingTrip.fare}</div>
                                            <div><strong>Payment</strong></div>
                                            <div>{upcomingTrip.paymentMode}</div>
                                        </div>

                                        <div className="col-2">
                                            <div><strong>Est. Distance</strong></div>
                                            <div>{upcomingTrip.estimatedDistance}</div>
                                            <div className="mt-2"><strong>Est. Pickup Time</strong></div>
                                            <div>{upcomingTrip.estimatedPickupTime}</div>
                                        </div>

                                        <div className="col-2 text-muted">
                                            <div><strong>Vehicle</strong></div>
                                            <div className="text-danger fw-bold mb-2">{upcomingTrip.status}</div>
                                        </div>

                                        <div className="col-1 d-flex flex-column align-items-center">
                                            <Button variant="danger" size="sm">CANCEL</Button>
                                        </div>
                                    </div>
                                </Card> */}
                                {UserTravelHistory.filter(trip =>
                                // console.log("Trip")
                                    new Date(trip.RequestedPickUpTime) > currentTime // Compare times
                                ).map((upcomingTrips, index) => (
                                    // console.log("upcomingTrips:", upcomingTrips),
                                    <Card key={index} className="trip-card p-3">
                                        <div
                                            className="d-flex flex-wrap align-items-center"
                                            // style={{ marginLeft: "40px", marginRight: "-70px" }}
                                        >
                                            <div className="col-2">
                                                <div><strong>Booking ID:</strong> {upcomingTrips.bookingId}</div>
                                                <div>{upcomingTrips.TypeOfTrip}</div>
                                                <div>{upcomingTrips.RequestedPickUpTime}</div>
                                            </div>

                                            <div className="col-6">
                                                <div className="d-flex align-items-start mb-2">
                                                    <img
                                                        src="dist/img/location-green.png"
                                                        alt="Pickup"
                                                        style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
                                                    />
                                                    <div>{upcomingTrips.pickup}</div>
                                                </div>
                                                <div className="d-flex align-items-start">
                                                    <img
                                                        src="dist/img/location-blue.png"
                                                        alt="Drop"
                                                        style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
                                                    />
                                                    <div>{upcomingTrips.drop}</div>
                                                </div>
                                            </div>

                                            <div className="col-1">
                                                <div><strong>Fare</strong></div>
                                                <div>₹ {upcomingTrips.fare}</div>
                                                <div><strong>Payment</strong></div>
                                                <div>{upcomingTrips.paymentMode}</div>
                                            </div>

                                            <div className="col-2">
                                                <div><strong>Estimated Distance</strong></div>
                                                <div>{upcomingTrips.estimatedDistance}</div>
                                                {/* <div className="mt-2"><strong>Est. Pickup Time</strong></div>
                                                <div>{upcomingTrips.estimatedPickupTime}</div> */}
                                            </div>

                                            <div className="col-2 text-muted">
                                                <div><strong>Vehicle</strong></div>
                                                <div className="text-danger fw-bold mb-2">{upcomingTrips.status}</div>
                                            </div>

                                            <div className="col-1 d-flex flex-column align-items-center">
                                                <Button variant="danger" size="sm">CANCEL</Button>
                                            </div>
                                        </div>
                                    </Card>
                                ))}

                            </div>

                            <div className="history-section">


                                <div
                                    className="history-filters mb-3 d-flex gap-2 align-items-center flex-wrap justify-content-between"
                                    style={{ marginTop: "-60px" }}
                                >
                                    
                                    <h4 className="section-title">History</h4>

                                    <div className="d-flex align-items-center">
                                        <Form.Select
  className="w-auto rounded shadow-sm border-primary"
  style={{
    minWidth: "200px",
    height: "36px",
    padding: "8px",
    fontSize: "13px",
    marginRight: "36px"
  }}
  value={selectedStatus}
  onChange={(e) => setSelectedStatus(e.target.value)}
>
  <option value="">Select Status</option>
  <option value="Dispatching">Dispatching</option>
  <option value="Vehicle Assigned">Vehicle Assigned</option>
  <option value="Ongoing">Ongoing</option>
  <option value="Cancelled">Cancelled</option>
</Form.Select>

                                        <InputGroup className="search-box" style={{ maxWidth: "300px" }}>
                                            <Form.Control placeholder="Search" value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}  />
                                            {/* <InputGroup.Text>
                                                <i className="bi bi-search"></i>
                                            </InputGroup.Text> */}
                                        </InputGroup>
                                    </div>
                                </div>



                                {/* {tripHistory.map((trip, index) => (
                                    <Card key={index} className="trip-card p-3 mb-3">
                                        <div className="d-flex flex-wrap align-items-center">

                                            <div className="col-2">
                                                <div><strong>Booking ID:</strong> {trip.bookingId}</div>
                                                <div>{trip.tripType}</div>
                                                <div>{trip.dateTime}</div>
                                            </div>

                                            <div className="col-6">
                                                <div className="d-flex align-items-start mb-2">
                                                    <img
                                                        src="dist/img/location-green.png"
                                                        alt="Pickup"
                                                        style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
                                                    />
                                                    <div>{trip.pickup}</div>
                                                </div>
                                                <div className="d-flex align-items-start">
                                                    <img
                                                        src="dist/img/location-blue.png"
                                                        alt="Drop"
                                                        style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
                                                    />
                                                    <div>{trip.drop}</div>
                                                </div>
                                            </div>

                                            <div className="col-1">
                                                <div><strong>Fare</strong></div>
                                                <div>₹ {trip.fare}</div>
                                                <div><strong>Payment</strong></div>
                                                <div>{trip.paymentMode}</div>
                                            </div>

                                            <div className="col-2">
                                                <div><strong>Est. Distance</strong></div>
                                                <div>{trip.estimatedDistance}</div>
                                                <div className="mt-2"><strong>Est. Pickup Time</strong></div>
                                                <div>{trip.estimatedPickupTime}</div>
                                            </div>

                                            <div className="col-2">
                                                <div><strong>Vehicle</strong></div>
                                                <div>Number: {trip.vehicle.number}</div>
                                                <div>Model: {trip.vehicle.model}</div>
                                                <div>Driver: {trip.vehicle.driverName}</div>
                                                <div>Contact: {trip.vehicle.driverContact}</div>
                                            </div>

                                            <div className="col-1 d-flex flex-column align-items-center">
                                                <Badge bg={trip.status === 'ONGOING' ? 'warning' : 'success'} className="mb-2">
                                                    {trip.status}
                                                </Badge>
                                                {trip.showTrack && (
                                                    <Button variant="primary" size="sm">TRACK</Button>
                                                )}
                                            </div>
                                        </div>
                                    </Card>
                                ))} */}

                                
                         <div className="trip-history-list" style={{ fontSize: "12px" }}>
  {filteredTrips  && filteredTrips.length > 0 ? (
    filteredTrips.map((trip, index) => (
      <Card key={index} className="trip-card p-3 mb-3">
        <div className="row g-3 align-items-center">
          {/* Column 1: Booking Info */}
          <div className="col-12 col-md-2">
            <div><strong>Booking ID:</strong> {trip.JobNo}</div>
            <div>{trip.TypeOfTrip}</div>
            <div>{trip.RequestedPickUpTime}</div>
          </div>

          {/* Column 2: Address Info */}
          <div className="col-12 col-md-4">
            <div className="d-flex align-items-start mb-2">
              <img
                src="dist/img/location-green.png"
                alt="Pickup"
                style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
              />
              <div>{trip.PickupAddress}</div>
            </div>
            <div className="d-flex align-items-start">
              <img
                src="dist/img/location-blue.png"
                alt="Drop"
                style={{ width: '16px', marginRight: '6px', marginTop: '2px' }}
              />
              <div>{trip.DropOffAddress}</div>
            </div>
          </div>

          {/* Column 3: Fare & Payment */}
          <div className="col-6 col-md-2">
            <div><strong>Fare</strong></div>
            <div>₹ {trip.CalculatedBaseFare}</div>
            <div><strong>Payment</strong></div>
            <div>{trip.BillingType}</div>
          </div>

          {/* Column 4: Distance */}
          <div className="col-6 col-md-1">
            <div><strong>Distance</strong></div>
            <div>{trip.CalculatedBaseKm}</div>
          </div>

          {/* Column 5: Vehicle Info */}
     <div className="d-flex align-items-center mb-2 mb-md-0">
    <img
      src="dist/img/Carimg.png"
      alt="Car"
      style={{ width: '40px', marginRight: '10px' }}
    />
    <div>
      <div className="fw-bold">{trip.VehicleModel}</div>
      {/* <div className={trip.JobStatus === "Cancelled" ? "text-danger fw-bold" : "text-muted"}>
        
      </div> */}{trip.VehicleNo}
      <div className="fw-bold">{trip.DriverName}</div>
      <div className="fw-bold">{trip.DriverMobileNo}</div>
    </div>
  </div>

  {/* Job Status */}
  <div className="col-6 col-md-1">
  {trip.CanCancel === "Yes" && trip.JobStatus !== "Cancelled" ? (
  <button
    className="btn btn-sm btn-danger"
    onClick={() => Canceltrip(trip.JobNo, trip.Id)}
    style={{ minWidth: "100px", marginLeft: "10px" }}
  >
    Cancel
  </button>
) : (
 <button
  className="fw-bold text-white text-center"
  disabled
  style={{
    backgroundColor: "rgba(28, 68, 129, 1)",
    // border: "2px solid hsla(216, 78%, 51%, 1)",
    borderRadius: "8px",
    padding: "6px 12px",
    minWidth: "100px",
    marginLeft: "10px",
    cursor: "default"
  }}
>
  {trip.JobStatus}
</button>

)}
</div>
        </div>
      </Card>
    ))
  ) : (
    <div
      className="text-center text-muted mt-4"
      style={{ fontSize: "16px", fontWeight: "500" }}
    >
      🚗 No bookings found.
    </div>
  )}
</div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default TripBooking;
